import React from 'react';
import { connect } from 'react-redux';
import { message } from 'antd'
import { getUser } from '../actions/app.action';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import BodyContainer from './common/BodyContainer';
import Home from './Home';
import "swagger-ui-react/swagger-ui.css";
import ServivePage from './ServivePage';
import ApiDocPage from './ApiDocPage';
import ApiPage from './ApiPage';
import ApiDocViewerPage from './ApiDocViewerPage';
import GuideLinePage from './GuideLinePage';
import { ProtectedRoute, PublicRoute } from './AuthenRoute';
import Admin from './Admin';
import ServiceEntryList from './Admin/ServiceEntry';
import ServiceEntryDetail from './Admin/ServiceEntry/detail';
import ApiDocDetail from './Admin/ApiDocs/detail';
import ApiDetail from './Admin/Apis/detail';
import NotFoundPage from './NotFoundPage';
import { ListTeam, CreateNewTeam, ListTeamService, AssignTeamService, ListTeamUsers, AssignTeamUser } from './Admin/Teams';
import { getUserProfile } from '../apis/user';
import { setUser } from '../actions/app.action';
import { getUserScope } from '../apis/scope';

class App extends React.Component {

  constructor(props) {
    super(props);
    this.getUserInfo = this.getUserInfo.bind(this);
  }

  // componentDidMount() {
  //   console.log('run to didmout token: ', localStorage.getItem('token'));
  //   this.getUserInfo();
  // }

  async getUserInfo(isPrivate = true) {
    let res = null;
    try {
      if (localStorage.getItem('token') != null) {

        res = await getUserProfile();
        if (res) {
          this.props.setUser(res);
        } else {
          this.props.setUser(null)
        }
      }
    } catch (error) {
      if (isPrivate) {
        message.error({
          content: 'The was a problem processing your request. Please try again',
          key: 'GET_USER_INFO'
        })
      }
      this.props.setUser(null)
    }

    try {
      const scopeRes = await getUserScope();
      if (scopeRes && res) {
        res.scope = scopeRes;
        this.props.setUser(res);
      } else {
        this.props.setUser(null);
      }

    } catch (error) {
      if (isPrivate) {
        message.error({
          content: 'The was a problem fetching user scope. Please try again'
        })
      }
      this.props.setUser(null)
    }
  }

  render() {
    return (
      <div className="container-fluid" style={{ minHeight: '100vh', background: '#f0f2f5' }}>
        <Router forceRefresh={false}>
          {/* <Header /> */}
          <BodyContainer>
            <Switch>
              <PublicRoute
                exact
                path="/"
                component={Home}
                getUser={this.getUserInfo}
              ></PublicRoute>
              <PublicRoute
                exact
                path="/service-entries/:id"
                component={ServivePage}
                getUser={this.getUserInfo}
              >
              </PublicRoute>
              <PublicRoute
                exact
                path="/api-docs/:id"
                component={ApiDocPage}
                getUser={this.getUserInfo}
              >
              </PublicRoute>
              <PublicRoute
                exact
                path="/apis/:id"
                component={ApiPage}
                getUser={this.getUserInfo}
              >
              </PublicRoute>
              <ProtectedRoute
                path="/admin/api-doc-view"
                component={ApiDocViewerPage}
                getUser={this.getUserInfo}
              ></ProtectedRoute>
              <ProtectedRoute path="/admin/guide-line" component={GuideLinePage} getUser={this.getUserInfo}></ProtectedRoute>
              <ProtectedRoute
                exact
                path="/admin"
                component={Admin}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/services"
                component={ServiceEntryList}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/services/:id"
                component={ServiceEntryDetail}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/api-docs/:id"
                component={ApiDocDetail}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/apis/:id"
                component={ApiDetail}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/teams/me"
                component={ListTeam}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/teams/create"
                component={CreateNewTeam}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/teams/:id/services"
                component={ListTeamService}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/teams/:id/services/assign"
                component={AssignTeamService}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/teams/:id/members"
                component={ListTeamUsers}
                getUser={this.getUserInfo}
              />
              <ProtectedRoute
                exact
                path="/admin/teams/:id/members/assign"
                component={AssignTeamUser}
                getUser={this.getUserInfo}
              />
              <Route path="*">
                <NotFoundPage />
              </Route>
            </Switch>
          </BodyContainer>
        </Router>
      </div>
    );
  }

}

const mapStateToProps = state => ({
});

const mapPropsToDispatch = dispatch => ({
  getUser: (token) => dispatch(getUser(token)),
  setUser: (userInfo) => dispatch(setUser(userInfo))
});

export default connect(mapStateToProps, mapPropsToDispatch)(App);
